import { Button, DialogContainer, Field, OptionalField } from '@components'
import { usePotentialHighQuality, user, userId } from '@state'
import { type Setter, Show, createEffect, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { Flex, Grid } from 'styled-system/jsx'
import { useSingle } from '../../state'

export function SingalPhq(props: { isOpen: boolean; setIsOpen: Setter<boolean> }) {
	const { setupResource, setupPotentialHigQualityResourceRefetch } =
		useService(useSingle)()
	const { setCreatePotentialHighQuality, createPotentialHighQualityResource } =
		useService(usePotentialHighQuality)()
	const [message, setMessage] = createSignal('')

	const onConfirm = () => {
		const created_by = userId()
		const setup_id = setupResource()?.id

		if (!created_by || !setup_id) return

		setCreatePotentialHighQuality({
			message: message(),
			created_by,
			setup_id,
		})
	}

	const onCancel = () => {
		props.setIsOpen(false)
	}

	createEffect(() => {
		if (createPotentialHighQualityResource.state === 'ready') {
			props.setIsOpen(false)
			setupPotentialHigQualityResourceRefetch()
		}
	})

	return (
		<Show when={props.isOpen}>
			<DialogContainer
				title="Signal PHQ"
				description="Flag this setup as potential high quality"
				isOpen={props.isOpen}
				setIsOpen={props.setIsOpen}
			>
				<Grid gap={4}>
					<Field.Root gap={4}>
						<OptionalField>
							<Field.Label>Description</Field.Label>
						</OptionalField>
						<Field.Textarea
							value={message()}
							onchange={({ target }) => setMessage(target.value)}
						/>
					</Field.Root>
					<Flex gap={2}>
						<Button
							variant="solid"
							colorPalette="tscGreen"
							onClick={onConfirm}
						>
							Confirm
						</Button>
						<Button
							loading={createPotentialHighQualityResource.loading}
							variant="outline"
							colorPalette="current"
							onClick={onCancel}
						>
							Cancel
						</Button>
					</Flex>
				</Grid>
			</DialogContainer>
		</Show>
	)
}
